<template>
  <bpb-form slot="content" v-model="fields" :before-submit-hook="submitHook">
    <bpb-form-url-sync />
    <slot />
  </bpb-form>
</template>

<script>
import debounce from 'lodash/debounce';

function GetObjectWithoutEmptyValues(object) {
  return Object.fromEntries(
    Object.entries(object)
      .sort(([key]) => key)
      .filter(([key, value]) => value != null && value != '')
  );
}

export default {
  inject: {
    setParam: {
      default() {
        return () => {};
      },
    },
    sync: {
      default() {
        return () => {};
      },
    },
    clearHistory: {
      default() {
        return () => {};
      },
    },
  },
  data() {
    return {
      fields: undefined,
      internalFields: {},
      lastURL: window.location.href,
    };
  },
  computed: {
    fieldsWithValue() {
      const fieldsWithValue = GetObjectWithoutEmptyValues(this.fields || {});
      return fieldsWithValue;
    },
    fieldsString() {
      return JSON.stringify(this.fieldsWithValue);
    },
  },
  watch: {
    fieldsString() {
      this.updateEndpointParams();
    },
  },
  mounted() {
    this.updateEndpointParams = debounce(this.updateEndpointParams, 200);
  },
  methods: {
    submitHook(fields) {
      this.clearHistory();
      this.sync();
      return false;
    },
    updateEndpointParams() {
      this.setParam('page', 0);
      // refresh whole object instead of using "reference"
      this.setParam('query', JSON.parse(JSON.stringify(this.fieldsWithValue)));
    },
  },
};
</script>
